(() => {
  if (customElements.get('product-specifications')) {
    return;
  }

  class ProductSpecifications extends HTMLElement {
    constructor() {
      super();

      this.tabs = this.querySelectorAll('[data-specification-tab]');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      theme.pubsub.subscribe(theme.pubsub.PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this)
      );
    }

    handleVariantChange({data}) {
      this.updateTab(data.variant.id);
    }

    updateTab(variantId) {
      this.tabs.forEach(tab => tab.classList.toggle('hidden', tab.dataset.variant != variantId));
    }
  }

  customElements.define('product-specifications', ProductSpecifications);
})();
